<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="TIT" id="tit"><img alt="image" height="800" src="images/68773_ch00_4P_fmt.jpeg" width="533"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?7834b630